<template>
    <v-menu location="bottom">
        <template v-slot:activator="{ props }">
            <v-btn v-bind="props" variant="outlined" outlined>
                {{ title }} <v-icon icon="mdi-menu-down"></v-icon>
            </v-btn>
        </template>

        <v-list>
            <v-list-item @click="filter = item" v-for="(item,index) in items" :key="index">
                <v-list-item-title><v-checkbox hide-details="true" density="compact" :label="item"></v-checkbox></v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script setup>
import { ref, inject, onMounted, computed, watch, getCurrentInstance, defineProps, defineEmits, defineModel } from 'vue';


const props = defineProps({
  items: {
    type:Array,
    required:true
  },
  title: {
    type:String,
    required:true
  }
});

const filter = defineModel();


</script>

<style lang="css" scoped></style>